'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationErrorToTrackingFailureType = undefined;

var _attachmentErrors = require('../constants/attachmentErrors');

var validationErrorToTrackingFailureType = exports.validationErrorToTrackingFailureType = function validationErrorToTrackingFailureType(errorType) {
  switch (errorType) {
    case _attachmentErrors.SIZE_LIMIT_EXCEEDED:
      return 'size limit exceeded';
    case _attachmentErrors.BLACKLISTED_EXTENSION:
      return 'blacklisted extension';
    default:
      return null;
  }
};


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/util/validationErrorToTrackingFailureType.js
// module id = 1175
// module chunks = 2 3